export default __webpack_public_path__ + "static/media/gtranslate-screenshot-04.22b7b75c.png";